import { Fragment, useCallback, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PriceTag from "../../assets/common/PriceTag.svg";
import Image from "../../components/general/Image";
import DashedChips from "../../components/common/DashedChips";
import { getShrunkText } from "../../utils";
import DummyProfile from "../../assets/common/DummyProfile.jpg";
import { EMPLOYMENT_TYPE } from "../../helpers/constants";
import { useDispatch } from "react-redux";
import { setDeveloperListByRoleSkills } from "../../redux/slice/homeSlice";

const DeveloperCard = ({ developers }) => {  
    const dispatch = useDispatch();

    const limitedSkills = useCallback((developer, index) => {
        if(developer.showMore) {
            return developer.skills.slice(0, 9);
        }
        return developer.skills.slice(0, 5);
    }, [developers]);
    
    const onShowMoreOrLessClick = (index, type) => {
        const updatedDevelopers = developers.map((developer, i) => 
            i === index 
                ? { ...developer, showMore: type ? true : false }
                : developer
        );
        dispatch(setDeveloperListByRoleSkills(updatedDevelopers));
    }

    return (
        <Fragment>
            {
                developers?.length > 0 && developers.map((developer, index) =>
                    <Link to={`/developer/${developer.slug}`} className="bg-[#292929] rounded-[10px] cursor-pointer block" key={developer.id}>
                        {
                            developer.display_pay_range && (
                            <div className="relative">
                                <Image className="absolute top-[20px] w-[80px] right-0 object-fill" src={PriceTag} alt="price-tag" />

                                <div className="relative z-1 top-[20px] pr-[10px] flex flex-col justify-end items-end">
                                    <span className="font-bold text-[1.0rem] text-black"> ${developer.display_pay_range} </span> 
                                    <span className="block text-[0.6rem]">Per Hour</span>
                                </div>
                            </div>
                            )
                        }
                        <div className="-mt-[20px]">
                            <div className="p-[20px]">
                                <div className="flex items-center justify-center">
                                    <figure className="w-[100px] h-[100px]">
                                        <Image className="w-full h-full object-cover rounded-[6px]" src={developer.profile_picture ? developer.profile_picture : DummyProfile} alt="" />
                                    </figure>
                                </div>
                                <div className="font-semibold text-[22px] mt-[20px] flex justify-center items-center gap-[10px]">
                                    <span>
                                        {developer.first_name} 
                                    </span>
                                    {
                                        developer.country && developer.country.flag && (
                                            <Image className="w-[30px] h-[20px]" src={developer.country.flag.file} alt="" />
                                        )
                                    }
                                </div>
                                <div className="text-center text-[#D7D7D7] font-extralight text-[0.8rem]">{developer.specialization}</div>
                                <div className="">
                                    <div className="mt-[20px]">
                                        <ul className="flex flex-wrap justify-start gap-[5px] items-center">
                                            {limitedSkills && limitedSkills(developer, index).map((skill, i) => {
                                                return (
                                                    <DashedChips keyName={i} text={skill} />
                                                )
                                            })}

                                            {
                                                developer.skills.length > 5 && (
                                                    !developer.showMore ? (
                                                        <small className="text-primary-color underline text-center" onClick={() => onShowMoreOrLessClick(index, true)}>See more</small>
                                                    )
                                                    :
                                                    <small className="text-primary-color underline text-center" onClick={() => onShowMoreOrLessClick(index, false)}>See less</small>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <p className="text-center mt-[20px] text-[0.7rem] text-[#EFF1F6]" title={developer.about}>{getShrunkText(developer.about, 100)}</p>
                            </div>
                            <div className="flex justify-between items-center border-y border-[#8b8a8a] py-[10px]">
                                <div className="w-[50%] border-r border-[#8b8a8a]">
                                    <p className="text-center text-[0.7rem] text-[#EFF1F6]">Experience</p>
                                    <p className="text-center font-semibold text-primary-color text-[0.8rem]">{developer.total_experience} years</p>
                                </div>
                                <div className="w-[50%]">
                                    <p className="text-center text-[0.7rem] text-[#EFF1F6]">Availability</p>
                                    <p className="text-center font-semibold text-primary-color text-[0.8rem]">{EMPLOYMENT_TYPE[developer.availability].displayValue} only</p>
                                </div>
                            </div>
                            <div className="py-[8px]">
                                <div className="flex justify-between px-[20px] py-[10px]">
                                    <span className="text-[0.8rem]">View Full profile</span> 
                                    <i className="fa-solid fa-arrow-up-right text-primary-color" />
                                </div>
                            </div>
                        </div>
                    </Link>
                )
            }
        </Fragment>
    );
};

export default DeveloperCard